(function () {
  const blogRegion = document.querySelector('#BlogDynamicRegion');
  const statusEl = document.getElementById('BlogDynamicStatus');
  const tagsDynamic = document.getElementById('BlogTagsDynamic');
  const tagsForm = document.querySelector('.blog-tags-form');

  if (!blogRegion || !tagsForm || !tagsDynamic) return;

  const mainSectionId = blogRegion.dataset.sectionId;
  const tagsSectionId = tagsForm.dataset.sectionId;
  if (!mainSectionId || !tagsSectionId) return;

  const i18n = window.__blogDynamicI18n || {
    loading: 'Loading',
    announcement: 'Blog posts updated',
  };

  function announce(message) {
    if (statusEl) statusEl.textContent = message;
  }

  function normalizeShopifyRoot() {
    let root =
      typeof window.Shopify !== 'undefined' &&
      window.Shopify.routes &&
      window.Shopify.routes.root
        ? String(window.Shopify.routes.root)
        : '/';
    if (root && !root.endsWith('/')) root = root + '/';
    return root;
  }

  function resolveStorefrontUrl(href) {
    if (!href || href === '#') return null;
    const raw = String(href).trim();
    const origin = window.location.origin;
    if (/^https?:\/\//i.test(raw)) {
      try {
        return new URL(raw);
      } catch {
        return null;
      }
    }
    if (raw.startsWith('?') || raw.startsWith('#')) {
      try {
        return new URL(raw, window.location.href);
      } catch {
        return null;
      }
    }
    const root = normalizeShopifyRoot();
    try {
      if (raw.startsWith('/')) {
        const pathOnly = raw.split('?')[0].split('#')[0];
        if (root !== '/') {
          const rootBase = new URL(root, origin);
          const rootPrefix = rootBase.pathname.replace(/\/$/, '');
          if (rootPrefix && pathOnly.startsWith(rootPrefix + '/')) {
            return new URL(raw, origin);
          }
        }
        const base = new URL(root, origin);
        return new URL(raw.slice(1), base);
      }
      return new URL(raw, new URL(root, origin));
    } catch {
      try {
        return new URL(raw, window.location.href);
      } catch {
        return null;
      }
    }
  }

  function buildSectionFetchUrl(resolvedUrl) {
    const u = new URL(resolvedUrl.href);
    u.searchParams.set('sections', [mainSectionId, tagsSectionId].join(','));
    return u.toString();
  }

  function buildBlogHistoryUrl(fetchTarget) {
    const u = new URL(fetchTarget.href);
    u.searchParams.delete('sections');
    const paginationRoot = blogRegion.querySelector('.pagination-wrapper');
    if (!paginationRoot) {
      u.searchParams.delete('page');
      return u.pathname + u.search + u.hash;
    }
    const currentEl = blogRegion.querySelector('.pagination__item--current');
    let pageNum = 1;
    if (currentEl) {
      const parsed = parseInt(String(currentEl.textContent || '').trim(), 10);
      if (Number.isFinite(parsed) && parsed > 0) pageNum = parsed;
    }
    if (pageNum <= 1) {
      u.searchParams.delete('page');
    } else {
      u.searchParams.set('page', String(pageNum));
    }
    return u.pathname + u.search + u.hash;
  }

  async function loadBlogAt(targetUrl, options) {
    const pushHistory = !options || options.pushHistory !== false;
    const scrollPostsToView = options && options.scrollPostsToView === true;
    const resolved = resolveStorefrontUrl(targetUrl);
    if (!resolved) {
      window.location.assign(targetUrl);
      return;
    }
    const fetchUrl = buildSectionFetchUrl(resolved);
    blogRegion.setAttribute('aria-busy', 'true');
    announce(i18n.loading);

    let res;
    try {
      res = await fetch(fetchUrl);
    } catch {
      window.location.assign(resolved.href);
      return;
    }

    if (!res.ok) {
      window.location.assign(resolved.href);
      return;
    }

    let data;
    try {
      data = await res.json();
    } catch {
      window.location.assign(resolved.href);
      return;
    }

    const mainHtml = data[mainSectionId];
    const tagsHtml = data[tagsSectionId];
    if (mainHtml == null || tagsHtml == null) {
      window.location.assign(resolved.href);
      return;
    }

    const parser = new DOMParser();
    const mainDoc = parser.parseFromString(mainHtml, 'text/html');
    const tagsDoc = parser.parseFromString(tagsHtml, 'text/html');
    const nextMain = mainDoc.querySelector('#BlogDynamicRegion');
    const nextTags = tagsDoc.querySelector('#BlogTagsDynamic');
    if (!nextMain || !nextTags) {
      window.location.assign(resolved.href);
      return;
    }

    blogRegion.innerHTML = nextMain.innerHTML;
    tagsDynamic.innerHTML = nextTags.innerHTML;

    blogRegion.removeAttribute('aria-busy');
    announce(i18n.announcement);

    if (pushHistory) {
      const barUrl = buildBlogHistoryUrl(resolved);
      try {
        history.pushState({ blogAjax: true }, '', barUrl);
      } catch {
        window.location.assign(resolved.href);
      }
    }

    if (scrollPostsToView) {
      blogRegion.scrollIntoView({ block: 'start' });
    }
  }

  tagsForm.addEventListener('submit', function (e) {
    const button = e.submitter;
    if (!button || button.type !== 'submit') return;
    e.preventDefault();
    let actionHref = button.getAttribute('formaction');
    if (!actionHref) actionHref = tagsForm.getAttribute('action') || window.location.pathname;
    const nav = resolveStorefrontUrl(actionHref);
    if (!nav) {
      window.location.assign(actionHref);
      return;
    }
    loadBlogAt(nav.href);
  });

  document.addEventListener(
    'click',
    function (e) {
      const link = e.target.closest('#BlogDynamicRegion .pagination a[href]');
      if (!link || !blogRegion.contains(link)) return;
      const href = link.getAttribute('href');
      if (!href || href === '#') return;
      e.preventDefault();
      const nav = resolveStorefrontUrl(href);
      if (!nav) return;
      loadBlogAt(nav.href, { scrollPostsToView: true });
    },
    true
  );

  window.addEventListener('popstate', function () {
    loadBlogAt(window.location.href, { pushHistory: false });
  });
})();
